import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";

import { Container, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import BlogRoll from "../../components/BlogRoll";
import Layout from "../../components/Layout";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "grid",
      gridArea: "content",
      marginBottom: theme.spacing(4),
      [theme.breakpoints.down("sm")]: {
        marginTop: theme.spacing(4),
        rowGap: `${theme.spacing(4)}px`
      },
      [theme.breakpoints.up("sm")]: {
        marginTop: theme.spacing(8),
        rowGap: `${theme.spacing(12)}px`
      }
    },
    // header: {
    //   minHeight: "20vh",
    //   width: "100%"
    // },
    heading: {
      paddingBottom: theme.spacing(4)
    },
    section: {
      [theme.breakpoints.down("sm")]: {
        marginTop: theme.spacing(4)
      },
      [theme.breakpoints.up("sm")]: {
        marginTop: theme.spacing(8)
      },
      marginBottom: theme.spacing(8)
    }
  })
);

export const BlogIndexPage = ({ location }): ReactElement => {
  const classes = useStyles();

  return (
    <Layout pathname={location.pathname}>
      <main className={clsx(classes.root)}>
        <header
          className={classes.header}
          // style={{
          //   backgroundImage: `url('/img/blog-index.jpg')`
          // }}
        >
          <Container component="div" fixed>
            <Typography
              className={clsx(classes.heading)}
              component="h1"
              variant="h2"
            >
              Our latest news and events
            </Typography>
          </Container>
        </header>
        <Container component="section" fixed>
          <BlogRoll />
        </Container>
      </main>
    </Layout>
  );
};

BlogIndexPage.propTypes = {
  location: PropTypes.object
};

export default BlogIndexPage;
